import React, { useState, useEffect } from "react";
import Modal from "../pop-up/modal";
import BuyTicket from "./buyTicket";

const Tickets = ({ ticketNo, ticket_id, price, purchaseTicket }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [purchaseTicketsCount, setPurchaseTicketsCount] = useState([]);
  const [isFlipped, setIsFlipped] = useState(false);

  const userId = localStorage.getItem("userID");

  /**
   * Updates the count of purchased tickets from the `purchaseTicket` prop.
   * This effect ensures that the UI reflects the correct number of tickets bought.
   */
  useEffect(() => {
    if (purchaseTicket?.length) {
      const ticketCounts = purchaseTicket.reduce((acc, ticket) => {
        const { ticket_id, ticket_quantity } = ticket;

        if (!acc[ticket_id]) {
          acc[ticket_id] = 0;
        }
        acc[ticket_id] += ticket_quantity;

        return acc;
      }, {});

      setPurchaseTicketsCount(ticketCounts);
    }
  }, [purchaseTicket]);

  const handleFlip = () => {
    if (modalOpen) return; // Prevent re-flipping if modal is open
    setIsFlipped((prev) => !prev);

    // Open modal after the animation completes
    if (!isFlipped) {
      setTimeout(() => setModalOpen(true), 700); // Match the animation duration
    }
  };

  /**
   * Closes the modal and resets the flip state after a short delay.
   */
  const closeModal = () => {
    setModalOpen(false);
    setTimeout(() => setIsFlipped(false), 300); // Add a slight delay for smooth flip back
  };

  return (
    <div className="flex items-center justify-center m-3">
      <div
        className="relative w-[90%] max-w-[170px] flex items-center cursor-pointer"
        onClick={handleFlip}
        role="button"
        aria-pressed={isFlipped}
      >
        <div className="relative w-[140px] h-[130px] m-[-24px] mb-5 perspective-1000">
          <div
            className={`relative w-full h-full transition-transform duration-700 ${
              isFlipped ? "rotate-y-180" : ""
            }`}
            style={{
              transformStyle: "preserve-3d",
            }}
          >
            {/* Front Side */}
            <div
              className="absolute w-full h-full backface-hidden "
              style={{
                transform: "rotateY(0deg)",
                backfaceVisibility: "hidden",
              }}
            >
              {/* Front Content */}
              {ticket_id in purchaseTicketsCount &&
                purchaseTicketsCount[ticket_id] > 0 && (
                  <div className="absolute top-[-30px] left-[50%] transform -translate-x-1/2 mt-[50px] ">
                    {/* Crown Image */}
                    <img
                      src="/images/crown.png"
                      alt="Crown"
                      className="w-10 h-7"
                    />
                    {/* Ticket Count */}
                    {purchaseTicketsCount[ticket_id] && (
                      <div
                        className="absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 
                text-black text-[12px] font-bold mt-[6px]"
                      >
                        {purchaseTicketsCount[ticket_id]}
                      </div>
                    )}
                  </div>
                )}

              <img
                src={`/images/card ${ticketNo}.png`}
                alt={`Card ${ticketNo}`}
                className="duration-300 w-[114px] h-[146px] m-2"
              />
            </div>

            {/* Back Side */}
            <div
              className="absolute w-full h-full backface-hidden"
              style={{
                transform: "rotateY(180deg)",
                backfaceVisibility: "hidden",
              }}
            >
              <img
                src="/images/card back.png"
                alt="Card Back"
                className="duration-300 w-[114px] h-[146px] m-2"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Buying Tickets */}
      <Modal
        isOpen={modalOpen}
        onClose={closeModal}
        className="bg-gradient-to-br from-pink-500 to-yellow-300 p-5 rounded-lg"
      >
        <BuyTicket
          ticket_id={ticketNo}
          user_id={userId}
          setModalOpen={closeModal}
          price={price}
          ticketCount={purchaseTicketsCount[ticket_id]}
        />
      </Modal>
    </div>
  );
};

export default Tickets;
